import React from 'react';
import PropTypes from 'prop-types';

import Linkify from 'linkify-react';

const shortUrl = (url) => {
  const shortUrlLength = 24;
  const urlNoProtocol = url.replace('http://', '').replace('https://', '');
  if (urlNoProtocol.length <= shortUrlLength) {
    return urlNoProtocol;
  }
  const uend = urlNoProtocol.slice(Math.max(urlNoProtocol.length - 15, shortUrlLength));
  const ustart = urlNoProtocol.substr(0, shortUrlLength);
  const shorter = `${ustart}...${uend}`;
  if (shorter.length - 3 >= urlNoProtocol.length) {
    return urlNoProtocol;
  }
  return shorter;
};

const LinkifyExt = ({ children }) => (
  <Linkify
    options={{
      defaultProtocol: 'https',
      target: '_blank',
      format: url => (shortUrl(url)),
    }}
  >
    {children}
  </Linkify>
);

LinkifyExt.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default LinkifyExt;
